import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import { useFetcherCache } from "../context/fetcherCache/FetcherCacheContext";
import { handleErrors } from "../services/handleErrors";

const useFetcher = (serviceFetcher, params = [], cacheKey) => {
  const { refreshToken } = useAuth();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const { getKeyValue, setKeyValue } = useFetcherCache();

  const fetchData = (newParams = undefined) => {
    setIsLoading(true);
    const cacheData = cacheKey && getKeyValue(cacheKey);
    if (!cacheData) {
      // eslint-disable-next-line prefer-spread
      serviceFetcher
        .apply(null, newParams || params)
        .then((result) => {
          setData(result.result);
          setError(false);
          setIsLoading(false);
          if (cacheKey) {
            setKeyValue(cacheKey, result.result);
          }
        })
        .catch((err) => {
          handleErrors(err, toast.error, refreshToken);
          setError(err);
          setIsLoading(false);
          if (cacheKey) {
            setKeyValue(cacheKey, undefined);
          }
        });
    } else {
      setData(cacheData);
      setError(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(params)]);

  return [data, isLoading, error, setData, fetchData];
};

export default useFetcher;
